import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { MESSAGE } from '../../../utils/message';
import SearchBannerBox from "../searchBannerBox";
import OverviewSearchBox from "../overviewSearchBox";
import {
  SectionTitle,
  Title,
  ProfileTabViewSection,
} from './profileTabViewStyle';
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import { communityStoriesHandler } from "../../../redux/slices/donationCamp/communityStories-slice";
import * as Yup from "yup";
import { addCartDonateHandler } from "../../../redux/slices/donationCamp/addCartDonate-slice";
import { campDetailByIdByIdHandler } from "../../../redux/slices/donationCamp/campDetailById-slice";

const ProfileTabView = () => {
  const { id } = useParams();
  const navigate: any = useNavigate();
  const dispatch: any = useDispatch();
  const [editDonateNowOpen, setEditDonateNowOpen] = useState(false);
  const campDetails: any = useSelector((state: any) => state?.campDetailById?.data?.results);
  const communityStory: any = useSelector((state: any) => state?.communityStory?.data);
  const [page, setPage] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState<number | null>(1);
  const size = 10;


  useEffect(() => {
    dispatch(campDetailByIdByIdHandler(id));
    dispatch(communityStoriesHandler(id, selectedFilter, page, size));
  }, []);

  useEffect(() => {
    dispatch(communityStoriesHandler(id, selectedFilter, page, size));
  }, [page, selectedFilter,refresh]);

  useEffect(() => {
    refresh && dispatch(communityStoriesHandler(id, selectedFilter, page, size));
  }, [refresh]);

  const donationAmount = [
    { id: 1, value: "$50", amount: 50 },
    { id: 2, value: "$100", amount: 100 },
    { id: 3, value: "$250", amount: 250 },
    { id: 3, value: "$500", amount: 500 },
    { id: 3, value: "Other", amount: '' }
  ];
  const formik = useFormik({
    initialValues: {
      org_id: "",
      amount: "",
    },
    validationSchema: Yup.object({
      amount: Yup.number().required(MESSAGE.requiredErrors("Amount")).max(10000000000, MESSAGE.maxDigitErrors("Amount", 10)),
    }),
    onSubmit: (values: { org_id: string, amount: string }, { resetForm }) => {
      const data = {
        org_id: id as string,
        amount: Number(values.amount)
      };
      if (data.amount > 0) {
        dispatch(addCartDonateHandler(data)).then((_: any) => {
          navigate("/donate-now")
        })
        resetForm({});
      }
    },
  });
  return (
    <>
      <SectionTitle>
        <Title>{MESSAGE.profile}</Title>
      </SectionTitle>

      <ProfileTabViewSection>
        <SearchBannerBox campDetails={campDetails} donationAmount={donationAmount} editDonateNowOpen={editDonateNowOpen} setDonateNowOpen={setEditDonateNowOpen} formik={formik} imageSlider={false} id={id} />

        {/* <OverviewSearchBox campDetails={campDetails}  selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} setDonateNowOpen={setEditDonateNowOpen} communityStory={communityStory} pageName="dashboard-profile" page={page} setPage={setPage} setRefresh={setRefresh}/> */}
        <OverviewSearchBox
          campDetails={campDetails}
          communityStory={communityStory}
          id={campDetails?.id}
          page={page}
          setPage={setPage}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          setRefresh={setRefresh}
          refresh={refresh}
        />
      </ProfileTabViewSection>
    </>
  )
}

export default ProfileTabView
